import { categories } from '@/mocks/categories';

export default function CategoryGridSection() {
  return (
    <section id="categories" className="w-full py-16 md:py-24 px-4 md:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Shop by Category
          </h2>
          <p className="text-foreground-600 font-body text-base">
            Browse curated Hipobuy Spreadsheet product categories with organized research data
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5" data-product-shop="true">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group cursor-pointer"
            >
              <div className="rounded-2xl overflow-hidden aspect-[4/5] mb-3">
                <img
                  src={cat.imageUrl}
                  alt={`Hipobuy Spreadsheet ${cat.name} category`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 font-label text-center mb-1">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 font-body text-center">
                500+ Items
              </p>
              <div className="mt-2 flex justify-center">
                <span className="inline-flex items-center gap-1 px-4 py-1.5 border border-foreground-300 rounded-full text-xs font-medium text-foreground-700 font-label group-hover:bg-foreground-950 group-hover:text-background-50 group-hover:border-foreground-950 transition-all whitespace-nowrap">
                  View {cat.name}
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-xs"></i>
                  </span>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}